import { combineReducers } from 'redux';
import { userData } from './userData';

export const Reducers = combineReducers({
  userData,
});
